// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// Partials
import { PartialsModule } from '../../partials/partials.module';
// Pages
import { CoreModule } from '../../../core/core.module';

import { MaterialModule } from '../../pages/material.module';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ConversationManagerComponent } from './conversation-manager.component';

@NgModule({
	declarations: [
        ConversationManagerComponent
	],
	exports: [
		MaterialModule,
        ConversationManagerComponent,
        PartialsModule
		],
	imports: [
        PartialsModule,
        CoreModule,
        CommonModule,
        MaterialModule,
        TranslateModule.forChild(),
		// PerfectScrollbarModule,
		
		// ng-bootstrap modules
		NgbDropdownModule,
		// NgbTabsetModule,
		NgbTooltipModule
	],
	providers: []
})
export class ConversationManagerModule {
}
